const Loading = () => {
  return (
    <div className="Loading my-6">
      <div className="text-center">
        <p>Loading...</p>
      </div>
    </div>
  );
}

export default Loading;
